import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-735e1a38")

_pushScopeId("data-v-735e1a38")
const _hoisted_1 = { class: "vue-flex-row" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("未発行")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_label_text = _resolveComponent("label-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_label_text, { label: "担当" }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.accountName), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_label_text, {
      class: "date",
      label: "受診日"
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.karteDateString), 1)
      ]),
      _: 1
    }),
    (_ctx.karteNumber==='')
      ? (_openBlock(), _createBlock(_component_label_text, {
          key: 0,
          class: "karte",
          label: "カルテ No."
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_label_text, {
          key: 1,
          class: "karte",
          label: "カルテ No."
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.karteNumber), 1)
          ]),
          _: 1
        }))
  ]))
})